import React, { Suspense } from 'react'

const Modalpopup = React.lazy(() => import('./../atoms/Modal/popUp'))
const Youtube = React.lazy(() => import('react-youtube'))

const PLAYER_OPTS = {
  height: '440px',
  width: '100%',
  playerVars: { autoplay: 1 },
}

function getYoutubeId(link) {
  if (!link) return ''
  try {
    const u = new URL(link)
    if (u.hostname.includes('youtu.be')) return u.pathname.slice(1)
    const v = u.searchParams.get('v')
    if (v) return v
    const m = u.pathname.match(/\/embed\/([0-9A-Za-z_-]{11})/)
    if (m) return m[1]
  } catch (e) {}
  const m2 = String(link).match(/(?:v=|\/embed\/|youtu\.be\/)([0-9A-Za-z_-]{11})/)
  return m2 ? m2[1] : ''
}

// Only embed https URLs; anything else (javascript:, data:, etc.) is ignored.
function getDemoEmbedUrl(link) {
  try {
    const u = new URL(link)
    return u.protocol === 'https:' ? u.href : ''
  } catch (e) {
    return ''
  }
}

// Shared modal — rendered at the controller level so both the landing rows and
// the expanded grid open the same player. Lazy-loaded on first open.
// YouTube URLs use the YouTube player; any other https URL is treated as an
// interactive demo (Navattic) and embedded in an iframe. How the demo looks
// inside the modal is still TBD with design.
const VideoModal = ({ url, onClose }) => {
  if (!url) return null
  const videoID = getYoutubeId(url)
  const demoUrl = videoID ? '' : getDemoEmbedUrl(url)
  if (!videoID && !demoUrl) return null

  return (
    <Suspense fallback={null}>
      <Modalpopup isOpen={true} title={videoID ? 'Video' : 'Interactive Demo'} onClose={onClose}>
        <div className='VideoContainer'>
          {videoID ? (
            <Youtube videoId={videoID} opts={PLAYER_OPTS} />
          ) : (
            <iframe
              src={demoUrl}
              title='Interactive demo'
              allow='fullscreen'
              allowFullScreen
              style={{ width: '100%', height: PLAYER_OPTS.height, border: 0, display: 'block' }}
            />
          )}
        </div>
      </Modalpopup>
    </Suspense>
  )
}

export default VideoModal
